export const getOnlyValueFromSelectObject = (data) => {
  const newData = {};
  const form = new FormData();
  Object.keys(data).forEach((item) => {
    if (data[item]?.type) {
      newData[item] = data[item].value;
    } else {
      newData[item] = data[item];
    }
    if (Array.isArray(newData[item])) {
      newData[item] = newData[item].map((item) => {
        if (item !== "") {
          item = !isNaN(item) ? parseFloat(item) : item;
        }

        return item;
      });
      newData[item].forEach((data) => {
        form.append(`${item}[]`, data);
      });
    } else if (newData[item] !== "") {
      form.append(item, !isNaN(newData[item]) ? newData[item] : newData[item]);
    } else {
      form.append(item, newData[item]);
    }
  });

  return { newData, form };
};
